import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { IServicesBillingConfigResponse } from '../store/configurations.types'
import { ConfigurationsService } from '../services/configurations.service'
import * as actions from '../store/configurations.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setServicesBillingConfig() {
  const serviceId: string = yield select(getServiceIdSelector)
  const configurationsService = new ConfigurationsService(serviceId)
  try {
    const response: IServicesBillingConfigResponse = yield call([
      configurationsService,
      configurationsService.getServicesBillingDoc,
    ])
    const { entity } = response
    if (entity && entity.length) {
      yield put(actions.setServicesBillingConfig(entity[0]))
    }
  } catch (e) {
    yield put(throwPcrException(`setServicesBillingConfig() error: ${e}`))
  }
}

export function* setServicesBillingConfigSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setServicesBillingConfig)
}
